import type { HTMLAttributes } from 'react';
import { cn } from '../../../helpers/commonUtils';
import styles from './Panel.module.css';

export type PanelProps = HTMLAttributes<HTMLDivElement>;

export function Panel({ className, ...props }: PanelProps) {
    return <div className={cn(styles.panel, className)} {...props} />;
}
